import React, { useState } from 'react'
import './about.css'
import Navigation from '../../Component/Navigation/Navigation'
import aboutUS from '../../resources/images/about-1 (1).jpg'
import Footer from '../../Component/Footer/Footer'
import { Link } from 'react-router-dom'
import { toast } from 'wc-toast'
import aboutImg  from '../../resources/images/about-img.png'
import aboutImg1 from '../../resources/images/about-img-3.png'
import aboutImg2 from '../../resources/images/about-img-2.png'
import map from '../../resources/images/world-map.png'

function About() {
  const [NLEmail, setNLEmail] = useState(null)

  const handleNLSubmit = (e) => {
    e.preventDefault()
    if (!NLEmail) toast.error('Enter an Email')
    else toast.success('News Letter Signup Successful')
  }

  /* ── Stats data ───────────────────────────────────────────── */
  const stats = [
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      value: '50k+',
      label: 'Happy Clients',
    },
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>
        </svg>
      ),
      value: '90Bn',
      label: 'Total Transactions',
    },
    {
      icon: (
        <svg width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" viewBox="0 0 24 24">
          <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
        </svg>
      ),
      value: '20k+',
      label: 'Branches in USA',
    },
  ]

  return (
    <div className="about-page">
      <Navigation />

      {/* ══════════════════════════════════════════════════════
          PAGE HEADER
      ══════════════════════════════════════════════════════ */}
      <div className="ab-header">
        <div className="ab-header__content">
          <h1 className="ab-header__title">About Us</h1>
          <p className="ab-header__breadcrumb">Home &nbsp;/&nbsp; About Us</p>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          INTRO — Financial Guidance
      ══════════════════════════════════════════════════════ */}
      <div className="ab-intro">
        <div className="ab-intro__inner">

          <div className="ab-intro__image">
            <img src={aboutUS} alt="About JFE Bank" />
          </div>

          <div className="ab-intro__text">
            <span className="ab-eyebrow">About Us</span>
            <h2 className="ab-heading">
              Financial Guidance for Every <em>Stage of Life.</em>
            </h2>
            <p className="ab-body">
              Managing your finances is a lifelong journey with many milestones and
              obstacles along the way. Whether you're just starting out, in your
              prime working years, or preparing for retirement, having a sound
              financial plan is crucial for achieving your goals and qualifying for
              the banking products you need.
            </p>

            <div className="ab-intro__features">
              <div className="ab-feature">
                <div className="ab-feature__icon">
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <rect x="2" y="5" width="20" height="14" rx="2"/><path d="M2 10h20"/>
                  </svg>
                </div>
                <div className="ab-feature__text">
                  <h4>Solution Focused</h4>
                  <p>We are very focused on providing the best solution on financial Guidance</p>
                </div>
              </div>
              <div className="ab-feature">
                <div className="ab-feature__icon">
                  <svg width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/>
                  </svg>
                </div>
                <div className="ab-feature__text">
                  <h4>99.99% Success</h4>
                  <p>We are very focused on providing the best solution on financial Guidance</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <hr className="ab-rule" />

      {/* ══════════════════════════════════════════════════════
          AMBITION SPLIT
      ══════════════════════════════════════════════════════ */}
      <div className="ab-ambition">
        <div className="ab-ambition__inner">

          <div className="ab-ambition__text">
            <span className="ab-eyebrow">About Us</span>
            <h2 className="ab-heading">
              Your ally in achieving ambition <em>beyond borders</em>
            </h2>
            <p className="ab-body">
              We understand that with global ambition, comes global challenges, and we are
              here to bridge the gap by offering seamless cross-border financial services.
              Consider us your friendly digital guide to all things finance, helping you
              make the most of your money.
            </p>
            <div className="ab-ambition__check">
              Customer Satisfaction
            </div>
          </div>

          <div className="ab-collage">
            <img className="img1" src={aboutImg}  alt="Banking illustration 1" />
            <img className="img2" src={aboutImg1} alt="Banking illustration 2" />
            <img className="img3" src={aboutImg2} alt="Banking illustration 3" />
          </div>

        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          STATS BAR
      ══════════════════════════════════════════════════════ */}
      <div className="ab-stats">
        <div className="ab-stats__grid">
          {stats.map((s, i) => (
            <div className="ab-stat" key={i}>
              <div className="ab-stat__icon">{s.icon}</div>
              <div className="ab-stat__text">
                <strong>{s.value}</strong>
                <span>{s.label}</span>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          CORE VALUES + MAP
      ══════════════════════════════════════════════════════ */}
      <div className="ab-values">
        <div className="ab-values__head ab-wrap">
          <span className="ab-eyebrow">Our core values</span>
          <h2 className="ab-heading">
            Our values help us set the bar for <em>good banking</em> high.
          </h2>
          <p className="ab-body">
            Our values define us. They guide us in building and improving our product,
            hiring teammates, and serving our customers.
          </p>
        </div>

        <div className="ab-wrap">
          <div className="ab-map">
            <img src={map} alt="Global banking reach" />
          </div>
        </div>
      </div>

      {/* ══════════════════════════════════════════════════════
          NEWSLETTER
      ══════════════════════════════════════════════════════ */}
      <div className="ab-newsletter">
        <div className="ab-newsletter__inner">

          <div className="ab-newsletter__text">
            <h2>Subscribe to Receive Latest Updates</h2>
            <p>Stay informed with the latest news, offers, and financial insights from JFE Bank.</p>
          </div>

          <form className="ab-newsletter__form" onSubmit={handleNLSubmit}>
            <input
              type="email"
              placeholder="Your Email"
              onChange={(e) => setNLEmail(e.target.value)}
            />
            <input type="submit" value="Subscribe" />
          </form>

        </div>
      </div>

      <Footer />
    </div>
  )
}

export default About